import { Link } from "react-router-dom";
import { Button, Header, Icon, Segment } from "semantic-ui-react";

export default function NotFound() {
  return (
    <Segment placeholder>
      <Header icon>
        <Icon name="search" />
        Stranica nije mogla biti pronadjena!
      </Header>
      <Segment.Inline>
        <Button as={Link} to="/home">
          Vrati se na početnu stranicu
        </Button>
      </Segment.Inline>
    </Segment>
  );
}
